<script setup lang="ts">
import { computed, inject, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { setLocale } from '@/plugins/i18n';
import { VueCookies } from 'vue-cookies';

import Page from '@/views/Page.vue';
import { useCommunityStore } from '@/store/communityStore';
import { Locales } from '@/store/language.interface';

const communityStore = useCommunityStore();
const route = useRoute();
const router = useRouter();
const cookies = inject<VueCookies>('$cookies');

const locale = (route.params.locale as string)?.toLowerCase() as Locales;
if (locale && communityStore.community.languageEnabled.includes(locale)) {
  cookies.set('locale', locale);
  setLocale(locale);
}

const homepageId = computed(() => communityStore.community?.options?.pages?.homepage_id ?? null);

watch(
  () => homepageId.value,
  async (value) => {
    if (!value) {
      await router.replace({ name: 'not-found' });
    }
  },
  { immediate: true },
);
</script>

<template>
  <Page v-if="homepageId" :page-id="homepageId" is-homepage />
</template>
